import styled from 'styled-components';
import { Button, Select } from '@/ui';
import { COLORS, DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';
import { FormItem } from '@/components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2rem 1.5rem;
  background: ${COLORS.BG_SECONDARY};
  border-top: 1px solid ${COLORS.LIGHT_PURPLE};
`;

export const FormColumn = styled.div`
  flex-direction: column;
  gap: 1rem;
  display: flex;
`;

export const StyledFormItem = styled(FormItem)`
  flex: 1;
`;

export const FormRow = styled.div`
  gap: 1rem;
  display: flex;
  width: 100%;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  display: flex;
  align-items: center;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'BOLD')};
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    width: 100%;
    margin-bottom: 1rem;
    border-radius: 2rem;
    ${pickThemeFontStyles('14', '18', 'BOLD')};
  }
`;

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.DARK_PURPLE};
  text-align: left;
  margin-bottom: 1rem;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 2rem;
`;

export const StyledActionButton = styled(Button)`
  &&& {
    padding: 0.625rem 1rem;
    border: none;
    height: 2.125rem;
    ${pickThemeFontStyles('16', '20', 'SEMI_NORMAL')};
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;

export const StyledActivationButton = styled(StyledActionButton)`
  &&& {
    background-color: ${pickThemeColor('WHITE_SMOKE')};
  }
`;

export const StyledSelect = styled(Select)`
  &&& {
    height: 2.85rem;
  }
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'BOLD')};
      width: 100%;
      color: ${COLORS.WHITE};
    }
  }
`;
